<template>
  <div class="modal fade" id="calibrationTableModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-custom-width">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Calibration Curve</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th>Name</th>
                <th>Site</th>
                <th>Year</th>
                <th>Signal</th>
                <th>Norm</th>
                <th>Range</th>
                <th>N</th>
                <th>R²</th>
                <th>Sigma</th>
                <th>Bias</th>
                <th>Equation</th>
                <th>OWT</th>
                <th>LiDAR Serial Number</th>
                <th>Comments</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cal in calibrations" :key="cal.id">
                <td>{{ cal.name }}</td>
                <td>{{ cal.site }}</td>
                <td>{{ cal.year }}</td>
                <td>{{ cal.signalWavelength }}</td>
                <td>{{ cal.normWavelength }}</td>
                <td>{{ cal.rangeMin }}–{{ cal.rangeMax }} {{ cal.rangeUnit }}</td>
                <td>{{ cal.N }}</td>
                <td>{{ cal.r2 }}</td>
                <td>{{ cal.sigma }}</td>
                <td>{{ cal.bias }}</td>
                <td>{{ formatEquation(cal) }}</td>
                <td>{{ cal.OWT }}</td>
                <td>{{ cal.LSN }}</td>
                <td>{{ cal.comments }}</td>
                <td>
                  <!-- canEdit приходит с бэкенда: admin правит всё, operator — только свои.
                       Удаление — только admin. -->
                  <button
                    v-if="cal.canEdit !== false"
                    class="btn btn-sm btn-outline-primary me-1"
                    @click="edit(cal)"
                  >
                    <svg class="bi" width="16" height="16"><use xlink:href="~/bootstrap-icons/bootstrap-icons.svg#pencil"/></svg>
                  </button>
                  <button v-if="isAdmin" class="btn btn-sm btn-outline-danger" @click="remove(cal.id)">
                    <svg class="bi" width="16" height="16"><use xlink:href="~/bootstrap-icons/bootstrap-icons.svg#trash"/></svg>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'CalibrationTableModal',
  props: {
    calibrations: { type: Array, required: true }
  },
  data() {
    return {
      modal: null
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById('calibrationTableModal'));
  },
  methods: {
    open() {
      this.modal.show();
    },
    close() {
      this.modal.hide();
    },
    edit(cal) {
      this.$emit('edit', cal);
      this.close();
    },
    remove(id) {
      if (confirm('Delete this calibration?')) {
        this.modal.hide(); // закрываем модалку перед удалением
        this.$emit('delete', id);
      }
    },
    formatEquation(cal) {
      return `y = ${cal.coeffA}x³ + ${cal.coeffB}x² + ${cal.coeffC}x + ${cal.coeffD}`;
    }
  }
};
</script>
<style scoped>
  .modal-custom-width {
  max-width: 90% !important;  /* или фиксированное значение, например 1400px */
}
</style>